import { useLocaleState } from "ra-core";

import { useConfigurationContext } from "@/components/atomic-crm/root/ConfigurationContext";

// Compact amounts in the app locale, as on Atomic's deal cards.
export const useAmountFormat = () => {
  const { currency } = useConfigurationContext();
  const [locale] = useLocaleState();
  return (amount: number) =>
    amount.toLocaleString(locale, {
      notation: "compact",
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
      minimumSignificantDigits: 3,
    });
};
